import { makeStyles } from "@material-ui/core/styles";
import { AppBar, Box, Tab, Tabs } from "@mui/material";
import PropTypes from "prop-types";
import NotesTab from "./NotesTab";
import ProspectTab from "./ProspectTab";
import TaskTab from "./TaskTab";
import { useAuth0 } from "@auth0/auth0-react";
import ConnectedAccountsTab from "./ConnectedAccountsTab";
import { useState } from "react";
import { useEffect } from "react";

function TabPanel(props) {
  const { children, value, index, ...other } = props;

  return (<div role="tabpanel" hidden={value !== index} id={`simple-tabpanel-${index}`} aria-labelledby={`simple-tab-${index}`}    {...other}>
    {value === index && <Box p={3}>{children}</Box>}
  </div>);
}

TabPanel.propTypes = {
  children: PropTypes.node,
  index: PropTypes.any.isRequired,
  value: PropTypes.any.isRequired,
};

function a11yProps(index) {
  return {
    id: `simple-tab-${index}`,
    "aria-controls": `simple-tabpanel-${index}`,
  };
}

const useStyles = makeStyles((theme) => ({
  root: {
    flexGrow: 1,
    backgroundColor: theme.palette.background.paper,
  },
}));

const SimpleTabs = (props) => {
  const { user, isAuthenticated } = useAuth0();
  const classes = useStyles();
  const [tabValue, setTabValue] = useState(0);

  useEffect(() => {
    if (props?.prospectData?.airbnb_guest === 1) {
      setTabValue(props.tabValue);
    } else {
      if (props.tabValue !== 0) {
        setTabValue(props.tabValue);
      } else {
        if (isAuthenticated && user["https://propertydek.com/permissions"].indexOf("prospect-taskaccount:read") > -1) {
          setTabValue(0);
        } else {
          setTabValue(1);
        }
      }
    }
  }, [props.tabValue, props?.prospectData?.airbnb_guest])

  return (<div className={classes.root}>
    <AppBar position="static">

      {props?.prospectData?.airbnb_guest === 1 ? <Tabs value={tabValue} onChange={props.handleTabChange} aria-label="simple tabs example" variant="scrollable" scrollButtons="auto">
        <Tab key={0} value={0} label={"Notes"}  {...a11yProps(0)} />
      </Tabs> : <Tabs value={tabValue} onChange={props.handleTabChange} aria-label="simple tabs example" variant="scrollable" scrollButtons="auto">
        {isAuthenticated && user["https://propertydek.com/permissions"].indexOf("prospect-taskaccount:read") > -1 && <Tab key={0} value={0} label="Tasks" {...a11yProps(0)} />}
        {props?.prospectData?.all_applicants?.map((item, index) => {
          if (item?.is_submitted === 1) {
            return (<Tab key={index + 1} value={index + 1} label={item?.full_name} {...a11yProps(index + 1)} />);
          } else {
            return null;
          }
        })}

        {isAuthenticated && user["https://propertydek.com/permissions"].indexOf("prospect-taskaccount:read") > -1 && props?.prospectData?.all_applicants?.map((item, index) => {
          return (<Tab key={index + 1} value={props?.prospectData?.all_applicants?.length + index + 1} label={
            props?.prospectData?.all_applicants?.length > 1 ? "Conected Account for " + item?.first_name : "Conected Accounts"} {...a11yProps(props?.prospectData?.all_applicants?.length + index + 1)} />);
        })}

        {isAuthenticated && user["https://propertydek.com/permissions"].indexOf("prospect-note:read") > -1 && (<Tab key={props?.prospectData?.all_applicants?.length + 2} value={props?.prospectData?.all_applicants?.length * 2 + 1} label={"Notes"} {...a11yProps(props?.prospectData?.all_applicants?.length * 2 + 1)} />)}
      </Tabs>}


      {props?.prospectData?.airbnb_guest === 1 ? <TabPanel value={tabValue} index={0} key={0}>
        <NotesTab
          addNoteData={props?.addNoteData.bind(this)}
          editNoteData={props?.editNoteData.bind(this)}
          deleteNoteData={props?.deleteNoteData.bind(this)}
          applicant_id={props?.prospectData?.applicant_id}
          setSnackbarMsg={props?.setSnackbarMsg.bind(this)}
          setSnackbarOpen={props?.setSnackbarOpen.bind(this)}
          prospectData={props?.prospectData}
        />
      </TabPanel> : <>
        <TabPanel value={tabValue} index={0} key={0}>
          <TaskTab
            prospectData={props?.prospectData}
            updateTourList={props.updateTourList.bind(this)}
            setAddTourModalOpen={props.setAddTourModalOpen.bind(this)}
            setEditTourData={props.setEditTourData.bind(this)}
            setSnackbarMsg={props?.setSnackbarMsg.bind(this)}
            setSnackbarOpen={props?.setSnackbarOpen.bind(this)}
            setTourTimeSlotError={props?.setTourTimeSlotError.bind(this)}
            updateMandatoryChecks={props?.updateMandatoryChecks.bind(this)}
            updateTaskList={props?.updateTaskList.bind(this)}
            addTaskList={props?.addTaskList.bind(this)}
            deleteTaskList={props?.deleteTaskList.bind(this)}
            updateApplicantData={props?.updateApplicantData.bind(this)}
            followUpList={props?.followUpList}
            setFollowUpList={props?.setFollowUpList.bind(this)}
            setFollowUpEditData={props?.setFollowUpEditData}
            setOpenFollowUpModal={props?.setOpenFollowUpModal.bind(this)}
          />
        </TabPanel>

        {props?.prospectData?.all_applicants?.map((item, index) => {
          if (item?.is_submitted === 1) {
            return (<TabPanel value={tabValue} index={index + 1} key={index + 1}>
              <ProspectTab
                applicantData={item}
                apartment={props?.prospectData?.apartment}
                applicant_index={index}
                no_of_applicants={props?.prospectData?.no_of_applicants}
                updateFileList={props?.updateFileList.bind(this)}
                setSnackbarMsg={props?.setSnackbarMsg.bind(this)}
                setSnackbarOpen={props?.setSnackbarOpen.bind(this)}
                updateApplicantData={props?.updateApplicantData.bind(this)}
              />
            </TabPanel>);
          } else {
            return null;
          }
        })}

        {props?.prospectData?.all_applicants?.map((item, index) => {
          return (<TabPanel value={tabValue} index={props?.prospectData?.all_applicants?.length + index + 1} key={props?.prospectData?.all_applicants?.length + index + 1}>
            <ConnectedAccountsTab
              prospect={item}
              setIsConnectAccountModalOpen={props?.setIsConnectAccountModalOpen.bind(this)}
              setSnackbarMsg={props?.setSnackbarMsg.bind(this)}
              setSnackbarOpen={props?.setSnackbarOpen.bind(this)}
            />
          </TabPanel>);
        })}

        {isAuthenticated && user["https://propertydek.com/permissions"].indexOf("prospect-note:read") > -1 && (<TabPanel value={tabValue} index={props?.prospectData?.all_applicants?.length * 2 + 1} key={props?.prospectData?.all_applicants?.length * 2 + 1}>
          <NotesTab
            addNoteData={props?.addNoteData.bind(this)}
            editNoteData={props?.editNoteData.bind(this)}
            deleteNoteData={props?.deleteNoteData.bind(this)}
            applicant_id={props?.prospectData?.applicant_id}
            setSnackbarMsg={props?.setSnackbarMsg.bind(this)}
            setSnackbarOpen={props?.setSnackbarOpen.bind(this)}
            prospectData={props?.prospectData}
          />
        </TabPanel>)}
      </>}
    </AppBar>
  </div>);
};

export default SimpleTabs;